/**
 * User: CHT
 * Date: 2020/5/8
 * Time: 14:01
 */
import { APPEND_EMPTY_X_GAP, CONDITION_HEAD_NODE_HEIGHT, SHRINK_CLOSE_X_GAP } from './const';
import { uuid, mark } from './index';
import * as d3 from 'd3';
import { NodeLineType } from './types';
export default class GraphNode {
    $options;
    key;
    graph;
    coordinate;
    meta;
    // 计算X方法
    getCoordinateX;
    // 计算Y方法
    getCoordinateY;
    // 计算X的依赖集合
    coordinateXFnList;
    width; // 宽度
    height; // 高度
    angleList;
    // Y轴层级
    tier;
    constructor(props, graph) {
        const { coordinate = [0, 0], meta = null, width, height } = props;
        this.$options = props;
        const id = props[mark.relationMark] || uuid('node');
        this.key = uuid('node');
        this.graph = graph;
        this[mark.relationMark] = id;
        this.coordinate = [...coordinate];
        this.meta = meta;
        this.width = width;
        this.height = height;
    }
    createPath({ type }) {
        const path = d3.path();
        // 是否有下一个节点,并且下一个节点不是空节点
        const startX = this.coordinate[0] + this.width; // 开始x
        const startY = this.coordinate[1] + CONDITION_HEAD_NODE_HEIGHT / 2; // 开始y
        let endX = 0;
        switch (type) {
            case NodeLineType.INSERT:
                endX = startX + APPEND_EMPTY_X_GAP;
                break;
            case NodeLineType.SHRINK:
                endX = startX + SHRINK_CLOSE_X_GAP;
                break;
        }
        const endY = startY;
        path.moveTo(startX, startY);
        path.lineTo(endX, endY);
        path.closePath();
        return path;
    }
    createArc(type) {
        const startPath = d3.path();
        const endPath = d3.path();
        const startX = this.coordinate[0] + this.width + 3; // 开始节点x位置
        const startY = this.coordinate[1] + CONDITION_HEAD_NODE_HEIGHT / 2; // 开始节点y位置
        let endX = 0; // 结束位置x
        switch (type) {
            case NodeLineType.INSERT:
                endX = startX + APPEND_EMPTY_X_GAP - 6.5;
                break;
            case NodeLineType.SHRINK:
                endX = startX + SHRINK_CLOSE_X_GAP - 6.5;
                break;
        }
        const endY = startY; // 结束位置 y
        startPath.arc(startX, startY, 3, 0, Math.PI * 2, true);
        endPath.arc(endX, endY, 3, 0, Math.PI * 2, true);
        return {
            startPath,
            endPath,
        };
    }
    // 创建端点
    createTerminalPoint({ g, color, type }) {
        const { startPath, endPath } = this.createArc(type);
        g.append('path').classed(`line-end-point`, true).attr('d', endPath).attr('fill', color);
        if (this.meta?.extParam?.isMergeNode)
            return;
        g.append('path')
            .classed(`line-start-point`, true)
            .attr('data-id', this.meta?.extParam?.activeId)
            .attr('d', startPath)
            .attr('fill', color);
    }
    createLine({ g, style: { color }, type }) {
        const path = this.createPath({ type });
        g.append('path')
            .classed('line-path', true)
            .attr('data-id', this.meta?.extParam?.activeId)
            .attr('d', path)
            .attr('stroke-width', 1)
            .attr('fill', 'none')
            .attr('stroke', color);
        this.createTerminalPoint({ g, color, type });
    }
}
